module.exports = __webpack_public_path__ + "img/MCEC_3.263d7dba.jpg";